import React from "react";
import { Location } from "../Location";
import { IframeContent } from "./shared/IframeContent";
import locale from "@bonliva-crm/locale";
import { store } from "@store";
import { environment } from "../../../environments/environment";

interface Params {
  bookingId: string;
}

export class CustomerInvoiceLocation extends Location<Params> {
  constructor(bookingId: string) {
    super({ bookingId });
    (window as any).onmessage = (event) => {
      this.navigation.lockNavigation(
        "customerInvoiceSlider",
        event.data === "isModified:True",
        locale.FormUnSaveMessage
      );

      if (event.data === "shouldClose") {
        this.navigation.close();
        store().snackbars.success("Kundfaktura har sparats.");
      }
    };
  }

  render() {
    const { bookingId } = this.params;

    return (
      <IframeContent
        url={`${environment.timereportClientUrl}/invoice-form/${bookingId}`}
      />
    );
  }

  toURI() {
    const { bookingId } = this.params;
    return `/bookings/${bookingId}/invoice-form`;
  }
}
